<template>
  <a-spin :spinning="spinning">
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline">

        <a-row :gutter="24">
          <a-col :md="8" :sm="24">
            <a-form-item label="单据编号">
              <span class="ant-form-text">{{ formdata.billNo }}</span>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              label="供应商"
              required
            >
              <a-input-search
                placeholder="请选择供应商"
                @change="supplierTextChange"
                @search="onSupplierSelect"
                @click="onSupplierSelect"
                v-model="formdata.supplierName"
              />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item required>
              <a-radio-group :options="transTypeOptions" v-model="formdata.transType" />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="单据日期" required>
              <a-date-picker v-model="formdata.billDate" :format="format"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="交货日期" required>
              <a-date-picker v-model="formdata.deliveryDate" :format="format"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <div class="table-page-search-submitButtons">
              <a-button type="primary" @click="formSave" :loading="state.btn" :disabled="state.btn">保存修改</a-button>
              <a-dropdown :trigger="['click']">
                <a-menu slot="overlay">
                  <a-menu-item @click="addBtn">新建单据</a-menu-item>
                  <a-menu-item @click="createBtn" :disabled="creteBtnDisabled">{{creteBtnText}}</a-menu-item>
                  <a-menu-item @click="toList">历史单据</a-menu-item>
                  <a-menu-item @click="exportExcel">导出</a-menu-item>
                </a-menu>
                <a-button>
                  其他操作 <a-icon type="down" />
                </a-button>
              </a-dropdown>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider />
    <div>
      <a-alert type="info" showIcon style="margin-bottom: 10px">
        <span slot="message">
          <span>总数量：{{totalQty}}</span>
          <span style="margin-left: 30px">总金额：{{totalAmount}}</span>
        </span>
      </a-alert>
      <a-table
        bordered
        :dataSource="entries"
        :columns="columns"
        :pagination="false"
        rowKey="id"
        size="middle"
      >
        <div slot="rowIndex" slot-scope="text, record, index">
          <div class="actionIco">
            <a-icon type="plus-square" theme="twoTone" twoToneColor="#52c41a" style="font-size: 16px;cursor: pointer;position: absolute;top: -16px;left: 10px" @click="addRow(index)"/>
            <div></div>
            <a-icon type="minus-square" theme="twoTone" twoToneColor="#f5222d" style="font-size: 16px;cursor: pointer;position: absolute;top: 2px;left: 10px" @click="delRow(record.id)"/>
          </div>
          <div class="rowIndex">
            {{index +1}}
          </div>
        </div>
        <span slot="goods" slot-scope="text, record, index">
          <EntriesGoods :storeList="storeList" :goodsName="record.goodsName" :goodsId="record.goodsId" :rowindex="index" @inputChange="GoodsInputChange"></EntriesGoods>
        </span>
        <span slot="store" slot-scope="text, record, index">
          <EntriesStore
            :goodsId="record.goodsId"
            :storeName="record.storeName"
            :storeId="record.storeId"
            :rowindex="index"
            :storeList="storeList"
            @inputChange="storeInputChange"
          ></EntriesStore>
        </span>
        <span slot="qty" slot-scope="text, record, index">
          <EntriesQty :goodsId="record.goodsId" :value="record.qty" :rowindex="index" @inputChange="qtyInputChange"></EntriesQty>
        </span>
        <span slot="price" slot-scope="text, record, index">
          <EntriesPrice :goodsId="record.goodsId" :value="record.price" :rowindex="index" @inputChange="priceInputChange"></EntriesPrice>
        </span>
        <span slot="amount" slot-scope="text, record, index">
          <EntriesAmount :price="record.price" :qty="record.qty" :rowindex="index"></EntriesAmount>
        </span>
        <span slot="note" slot-scope="text, record, index">
          <EntriesNote :goodsId="record.goodsId" :value="record.note" :rowindex="index" @inputChange="noteInputChange"></EntriesNote>
        </span>
      </a-table>
    </div>
    <div style="margin-top: 15px">
      <a-textarea placeholder="暂无备注信息" :autosize="{ minRows: 2, maxRows: 6 }" v-model="formdata.note" />
    </div>

    <SupplierModal :visible="state.supplierModal" @handleCancel="supplierModalCancel" @handleOk="supplierModalOk"></SupplierModal>
  </a-card>
  </a-spin>
</template>
<script>
import moment from 'moment'

import SupplierModal from '@/components/Supplier/Modal'
import EntriesQty from '@/components/Entries/Edit/Qty'
import EntriesPrice from '@/components/Entries/Edit/Price'
import EntriesAmount from '@/components/Entries/Edit/Amount'
import EntriesStore from '@/components/Entries/Edit/Store'
import EntriesGoods from '@/components/Entries/Edit/Goods'
import EntriesNote from '@/components/Entries/Edit/Note'
import { commonStoreList } from '@/api/common'
import { editPurchaseBill, getPurchaseBillDetail } from '@/api/bill'
import { decimal, downloadExcel } from '@/utils/util'
import { STATUS_ACTIVE, TYPE_PURCHASE_BILL_IN, TYPE_PURCHASE_BILL_OUT, TYPE_ALL, CODE_FAIL } from '@/store/mutation-types'
import { excelPurchaseBillDetail } from '@/api/excel'
const defaultFormData = {
  billNo: '',
  supplierName: '',
  contactId: '',
  billDate: moment(),
  deliveryDate: moment(),
  transType: TYPE_PURCHASE_BILL_IN,
  note: ''
}
const entrieData = {
  id: '',
  goodsId: '',
  goodsName: '',
  storeName: '',
  storeId: '',
  qty: '',
  price: '',
  unitName: '',
  note: ''
}
export default {
  components: {
    SupplierModal,
    EntriesQty,
    EntriesPrice,
    EntriesAmount,
    EntriesStore,
    EntriesGoods,
    EntriesNote
  },
  data () {
    return {
      spinning: true,
      totalQty: 0,
      totalAmount: 0,
      columns: [
        {
          title: '#',
          dataIndex: 'rowIndex',
          className: 'text-center',
          scopedSlots: { customRender: 'rowIndex' },
          width: 50
        },
        {
          title: '商品',
          dataIndex: 'goodsName',
          className: 'text-center',
          scopedSlots: { customRender: 'goods' },
          width: 200
        },
        {
          title: '单位',
          dataIndex: 'unitName',
          className: 'text-center',
          width: 50
        },
        {
          title: '仓库',
          dataIndex: 'storeName',
          className: 'text-center',
          width: 150,
          scopedSlots: { customRender: 'store' }
        },
        {
          title: '数量',
          dataIndex: 'qty',
          className: 'text-center',
          width: 80,
          scopedSlots: { customRender: 'qty' }
        },
        {
          title: '购货单价',
          dataIndex: 'price',
          className: 'text-center',
          width: 100,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '购货金额',
          dataIndex: 'amount',
          className: 'text-center',
          width: 100,
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center',
          width: 180,
          scopedSlots: { customRender: 'note' }
        }
      ],
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      formdata: {},
      transTypeOptions: [
        { label: '购货', value: TYPE_PURCHASE_BILL_IN },
        { label: '退货', value: TYPE_PURCHASE_BILL_OUT }
      ],
      state: {
        btn: false,
        supplierModal: false
      },
      entries: [
      ],
      storeList: null,
      creteBtnText: '生成购货单',
      creteBtnText2: '',
      linkPath: {}
    }
  },
  methods: {
    toList () {
      this.$router.push({ name: 'PurchaseOrderList' })
    },
    supplierTextChange (e) {
      if (!e.data) {
        this.formdata.contactId = ''
      }
    },
    supplierModalCancel () {
      this.state.supplierModal = false
    },
    supplierModalOk (selectedRows) {
      this.state.supplierModal = false
      if (selectedRows.length > 0) {
        const rowData = selectedRows.pop()
        this.formdata.contactId = rowData.id
        this.formdata.supplierName = rowData.name
      }
    },
    onSupplierSelect () {
      this.state.supplierModal = true
    },
    formSave (e) {
      e.preventDefault()
      this.state.btn = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // 判断供应商
          if (!this.formdata.contactId) {
            this.$message.error('请选择供应商')
            this.state.btn = false
            return false
          }
          const saveData = Object.assign({}, values)
          saveData.contactId = this.formdata.contactId
          saveData.billDate = moment(this.formdata.billDate).format(this.format)
          saveData.deliveryDate = moment(this.formdata.deliveryDate).format(this.format)
          saveData.transType = this.formdata.transType
          saveData.note = this.formdata.note
          saveData.id = this.formdata.id
          let entries = [...this.entries]
          entries = entries.filter((item) => { return item.goodsId })
          if (entries.length <= 0) {
            this.$message.error('商品信息不能为空')
            this.state.btn = false
            return false
          }
          saveData.entries = entries
          console.log('提交的数据', saveData)
          // 数据提交
          editPurchaseBill(saveData).then(res => {
            if (res.status === CODE_FAIL) {
              this.$message.error(res.message || '请求出现错误，请稍后再试')
            } else {
              this.$message.success('修改' + (saveData.transType === TYPE_PURCHASE_BILL_IN ? '购货' : '退货') + '订单成功!')
              this.createBtnTextFuc()
            }
          }).catch(() => {
          }).finally(() => {
            this.state.btn = false
          })
        }
      })
    },
    addRow (index) {
      const uuid = this.createUuid()
      const data = Object.assign({}, entrieData, { id: uuid })
      this.entries.splice(index, 0, data)
    },
    delRow (id) {
      const dataSource = [...this.entries]
      if (dataSource.length === 1) {
        this.$message.error('至少保留一条分录')
        return
      }
      this.entries = dataSource.filter(item => item.id !== id)
    },
    createUuid () {
      return 'UUID' + (Math.ceil(Math.random() * 100)) + moment().format('YYYYMMDDHHmmss') + (Math.ceil(Math.random() * 1000))
    },

    initentries () {
      const len = this.entries.length
      if (len < 5) {
        for (let i = 1; i <= (5 - len); i++) {
          this.addRow(len)
        }
      }
    },
    // 数量变化
    qtyInputChange (data) {
      this.entries[data.rowindex].qty = data.value
    },
    // 单价变化
    priceInputChange (data) {
      this.entries[data.rowindex].price = data.value
    },
    loadStore () {
      commonStoreList({ status: STATUS_ACTIVE, all: true })
        .then(res => {
          this.storeList = res.result.data
        })
    },
    // 仓库变化
    storeInputChange (data) {
      this.entries[data.rowindex].storeId = data.value
    },
    // 商品变化
    GoodsInputChange (data) {
      if (this.entries.hasOwnProperty(data.rowindex) === false) {
        this.addRow(data.rowindex)
      }
      this.entries[data.rowindex].goodsName = data.value.goodsName
      this.entries[data.rowindex].goodsId = data.value.id
      this.entries[data.rowindex].storeId = data.value.defaultStoreId
      this.entries[data.rowindex].unitName = data.value.unit.name
      this.entries[data.rowindex].qty = '1'
      this.entries[data.rowindex].price = '0.0000'
    },
    // 备注变化
    noteInputChange (data) {
      this.entries[data.rowindex].note = data.value
    },
    addBtn () {
      this.$router.push({ name: 'PurchaseOrder' })
    },
    createBtn () {
      // 通过购货订单转化成购货单
      this.$router.push(this.linkPath)
    },
    createBtnTextFuc () {
      this.creteBtnText = '生成' + ((this.formdata.transType === TYPE_PURCHASE_BILL_IN) ? '购货' : '购货退货') + '单'
      this.creteBtnText2 = ((this.formdata.transType === TYPE_PURCHASE_BILL_IN) ? '购货' : '购货退货') + '订单'
      this.linkPath = {
        path: '/purchase/' + ((this.formdata.transType === TYPE_PURCHASE_BILL_IN) ? 'invoice' : 'recede'),
        query: { srcbillid: this.formdata.id }
      }
    },
    exportExcel () {
      excelPurchaseBillDetail({ id: this.$route.params['id'] }).then(res => {
        downloadExcel(this.creteBtnText2 + '：' + this.formdata.billNo, res)
      })
    }
  },
  created () {
    const _this = this
    getPurchaseBillDetail({ id: _this.$route.params['id'] }).then((res) => {
      if (res.status === CODE_FAIL) {
        this.$message.error(res.message || '请求出现错误，请稍后再试')
        this.$router.push({ name: 'PurchaseOrderList' })
      } else {
        const result = res.result
        this.formdata = Object.assign({}, defaultFormData)
        this.formdata.id = result.id
        this.formdata.billNo = result.billNo
        this.formdata.supplierName = result.supplier.name
        this.formdata.contactId = result.supplier.id
        this.formdata.transType = result.transType
        this.formdata.note = result.note
        this.formdata.billDate = moment(result.billDate)
        this.formdata.deliveryDate = moment(result.deliveryDate)
        this.formdata.billStatus = result.billStatus
        //
        this.createBtnTextFuc()
        result.entries.forEach(function (item) {
          const row = {
            id: item.id,
            goodsId: item.goodsId,
            goodsName: (item.goods.name + (item.goods.type ? '_' + item.goods.type : '')),
            storeName: item.store.name,
            storeId: item.storeId,
            qty: item.qty,
            price: item.price,
            unitName: item.unit.name,
            note: item.note
          }
          _this.entries.push(row)
        })
        this.initentries()
      }
    }).catch(() => {
    }).finally(() => {
      this.spinning = false
    })
    this.loadStore()
  },
  computed: {
    'creteBtnDisabled' () {
      return (this.formdata.billStatus === TYPE_ALL)
    }
  },
  watch: {
    'entries': {
      handler: function () {
        const entries = [...this.entries]
        const vm = this
        console.log('entries检测有变化哦', entries)
        vm.totalQty = 0
        vm.totalAmount = 0
        entries.forEach(function (item, index, array) {
          if (item.goodsId) {
            const totalAmount = Number(item.qty) * Number(item.price)
            vm.totalQty += Number(item.qty)
            vm.totalAmount += decimal(totalAmount, 4)
          }
        })
      },
      deep: true
    }
  }

}
</script>

<style>
  td {
    height: 48px!important;
    min-height: 48px!important;
    word-wrap: normal;
    word-break: normal;
    white-space: nowrap;
  }
  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
  .ant-table td { white-space: nowrap; }
  .ant-table .actionIco {
    position: relative;
  }
  .ant-table .rowIndex {
    display: block;
  }
  .ant-table .actionIco {
    display: none;
  }
  .ant-table tr:hover .actionIco {
    display: block;
  }
  .ant-table tr:hover .rowIndex {
    display: none;
  }
  .ant-table-footer {
    padding: 0;
  }
  .ant-table-footer:before {
    height: 0!important;
  }
  .ant-divider-horizontal {
    margin: 0 0 10px;
  }
  .table-page-search-submitButtons .ant-btn {
    margin-right: 8px;
  }
</style>
